import { ContentSection, Heading } from '@cinch-labs/design-system'
import { StoryBlokRichText, StoryblokImage } from '@cinch-nx/data-storyblok'
import Image from 'next/legacy/image'

import renderWithResolver from '../../rich-text-renderer/rich-text-renderer'
import styles from './peace-of-mind.module.css'

export interface PeaceOfMindProps {
  image: StoryblokImage
  title: string
  aboveImageBody: StoryBlokRichText
  belowImageBody: StoryBlokRichText
}

const PeaceOfMind: React.FC<PeaceOfMindProps> = ({
  image,
  title,
  aboveImageBody,
  belowImageBody,
}) => {
  const aboveImageText = () => (
    <>
      <Heading className={styles.title}>{title}</Heading>
      <ContentSection
        sectionWrapperClass={styles.richAboveTextSectionWrapper}
        classNames={{ body: styles.body }}
      >
        {renderWithResolver(aboveImageBody)}
      </ContentSection>
    </>
  )

  return (
    <section className={styles.featureSectionWrapper}>
      <div className={styles.container} data-testid="peace-of-mind-container">
        <div className={styles.contentWrapper}>
          <div className={styles.mobileAboveImageText}>{aboveImageText()}</div>
          <div className={styles.imageWrapper}>
            <Image
              src={image.filename}
              alt={image.alt ?? undefined}
              layout="fill"
              objectFit="cover"
            />
          </div>
          <div>
            <div className={styles.desktopAboveImageText}>
              {aboveImageText()}
            </div>
            <ContentSection
              sectionWrapperClass={styles.richBottomTextSectionWrapper}
              classNames={{ body: styles.body }}
            >
              {renderWithResolver(belowImageBody)}
            </ContentSection>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PeaceOfMind
